var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M3.547 9.6v4.9a.741.741 0 001.3.5l2.3-2.7 4.7 3.5a.7.7 0 001.1-.4l3-14.5a.714.714 0 00-1-.8L.447 5.9a.8.8 0 00-.2 1.3l1.6 1.2 4.6-2.2c.4-.2.7.3.4.5z","fill":"#53647f","data-name":"Layer 1"})));
}

Send.defaultProps = {"width":"16","height":"16"};

module.exports = Send;

Send.default = Send;
